import useSWR from "swr";
import { getAvailableApis } from "../services/template-service";
import type {
  AvailableApisResponse,
  AvailableApiItem,
} from "../types/api-types";

export interface UseAvailableApisReturn {
  availableApis: AvailableApiItem[] | undefined;
  isLoading: boolean;
  // SWR returns any, so a more explicit type cannot be used
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
}

const useAvailableApis = (): UseAvailableApisReturn => {
  const { data, error, isLoading } = useSWR<AvailableApisResponse>(
    "available-apis",
    getAvailableApis,
  );

  return {
    availableApis: data?.results,
    isLoading,
    error,
  };
};

export default useAvailableApis;
